<template>
  <div class="payroll-wrapper">

    <button
      class="download-btn"
      :disabled="loading"
      @click="downloadPayroll"
    >
      <span v-if="!loading">
        📥 Download Payroll Excel
      </span>

      <span v-else class="btn-loading">
        <span class="spinner"></span>
        Preparing file... {{ progress }}%
      </span>
    </button>

    <!-- Progress Bar -->
    <div v-if="loading" class="progress-container">
      <div
        class="progress-bar"
        :style="{ width: progress + '%' }"
      ></div>
    </div>

    <!-- Success Message -->
    <div v-if="successMessage" class="alert success">
      {{ successMessage }}
    </div>

    <!-- Error Message -->
    <div v-if="errorMessage" class="alert error">
      {{ errorMessage }}
    </div>

  </div>
</template>

<script>
import payrollApi from "@/api/payrollApi";

export default {
  data() {
    return {
      loading: false,
      progress: 0,
      successMessage: "",
      errorMessage: "",
      fakeInterval: null
    };
  },

  methods: {
    async downloadPayroll() {
      this.resetState();
      this.loading = true;

      // Fake smooth progress until real response completes
      this.fakeInterval = setInterval(() => {
        if (this.progress < 90) {
          this.progress += 5;
        }
      }, 200);

      try {
        const response = await payrollApi.downloadPayrollExcel(null, {
          onDownloadProgress: (event) => {
            if (event.lengthComputable) {
              this.progress = Math.round(
                (event.loaded * 100) / event.total
              );
            }
          }
        });

        if (!response || !response.data || response.data.size === 0) {
          throw new Error("No payroll data available.");
        }

        this.progress = 100;
        clearInterval(this.fakeInterval);

        const url = window.URL.createObjectURL(
          new Blob([response.data])
        );

        const month = new Date().toLocaleString("default", {
          month: "short",
          year: "2-digit"
        });

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `ASL_Payroll_Deductions_${month}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.successMessage = "ASL Payroll deductions downloaded successfully ✔";
      } catch (error) {
        console.error(error);
        this.errorMessage =
          "Failed to download payroll file. Please try again.";
      } finally {
        clearInterval(this.fakeInterval);

        setTimeout(() => {
          this.loading = false;
          this.progress = 0;
        }, 800);
      }
    },

    resetState() {
      this.successMessage = "";
      this.errorMessage = "";
      this.progress = 0;
    }
  }
};
</script>

<style scoped>
.payroll-wrapper {
  max-width: 400px;
}

.download-btn {
  width: 100%;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  background-color: #1e3a8a;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s ease;
}

.download-btn:hover:not(:disabled) {
  background-color: #162d6b;
}

.download-btn:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
}

.btn-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Spinner */
.spinner {
  width: 16px;
  height: 16px;
  border: 3px solid #fff;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Progress Bar */
.progress-container {
  margin-top: 8px;
  height: 6px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #2563eb);
  transition: width 0.3s ease;
}

/* Alerts */
.alert {
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
}

.success {
  background-color: #d1fae5;
  color: #065f46;
}

.error {
  background-color: #fee2e2;
  color: #7f1d1d;
}
</style>
